import { State } from 'src/redux';

export const getCurrentUser = (state: State) => state.users.currentUser;
export const getUsers = (state: State) => state.users.users;
export const getMembers = (state: State) => state.users.members;
export const getUserRoles = (state: State) => state.users.userRoles;
